/**
 * Stable CSS class names for E2E — StoreReturn page (and its filter drawer).
 * Used by the test automation team as deterministic selectors.
 * Containers use `store-return__<element>`; inputs and user-interactable
 * controls use `store-return-input--<name>`.
 */
export const SR = {
    page: 'store-return-page',
    root: 'store-return',

    breadcrumb: 'store-return__breadcrumb',

    filterDrawer: 'store-return__filter-drawer',
    filterForm: 'store-return__filter-form',
    filterFormBody: 'store-return__filter-form-body',
    filterFormGrid: 'store-return__filter-form-grid',
    filterDrawerHeader: 'store-return__filter-drawer-header',
    filterCityField: 'store-return__filter-city-field',
    filterCountyField: 'store-return__filter-county-field',
    filterListAction: 'store-return__filter-list-action',
    inputCity: 'store-return-input--city',
    inputCounty: 'store-return-input--county',
    btnList: 'store-return-input--button-list',

    listResults: 'store-return__list-results',
    listHeader: 'store-return__list-header',
    listHeaderIcon: 'store-return__list-header-icon',
    listHeaderTitle: 'store-return__list-header-title',

    searchBox: 'store-return__search-box',
    inputSearchStore: 'store-return-input--search-store',

    openFilterBox: 'store-return__open-filter-box',
    btnOpenFilter: 'store-return-input--button-open-filter',
    btnOpenFilterIcon: 'store-return__open-filter-icon',

    grid: 'store-return__grid',

    cellCity: 'store-return__cell-city',
    cellCounty: 'store-return__cell-county',
    cellStoreName: 'store-return__cell-store-name',
    cellLocation: 'store-return__cell-location',
    /** Map-open button rendered inside the location cell. */
    btnOpenLocation: 'store-return-input--button-open-location',

    emptyState: 'store-return__empty-state',
    emptyStateNoRecord: 'store-return__empty-state-no-record',
    btnEmptyFilter: 'store-return-input--button-empty-filter',
} as const;

export const srCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
